// extracted by mini-css-extract-plugin
export default {"section":"HistoryUser_section__hCtUt","inputContainer":"HistoryUser_inputContainer__xmGHr","label":"HistoryUser_label__ONuvW"};